import { action, get, post, put } from 'lib/actionHelpers.js';

import jwtDecode from 'jwt-decode';
import { push } from 'connected-react-router';
import { store } from 'redux/lib/configureStore.js';
import setDeep from '../../lib/setDeep.js';
import { setToken } from '../../lib/authHelpers.js';
import { FullStoryAPI } from 'react-fullstory';
import { getServiceProvider } from './serviceProviderActions';

export const logoutAndRedirect = ({ saveRedirectPath = false }) => {
  if (saveRedirectPath && !window.location.pathname.includes('login')) {
    action('SET_REDIRECT_FROM_LOGIN_PATH', `${window.location.pathname}${window.location.search || ''}`);
  }
  action('LOGOUT');
  localStorage.removeItem('token');
  [...Object.keys(localStorage)]
    .filter((n) => n.match(/^persist:/))
    .filter((n) => n !== 'persist:appReducer')
    .forEach((n) => localStorage.removeItem(n));
  action('DELETE_LAST_SETTINGS_LOAD');
  setTimeout(() => {
    window.location = '/login';
  }, 0);
};

export const loginAndRedirect = (token) => {
  setToken(token);
  action('LOGIN_SUCCESS', token);
  store.dispatch(push(window.location.pathname));
};

export const getMercureToken = (callback) => {
  return get(`/user/get-pub-sub-token`, {
    action: 'GET_MERCURE_TOKEN',
    callback,
  });
};

export const postLogin = (data, callback) => {
  return post(`/user/login`, {
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    action: 'POST_LOGIN',
    modifyResponse: (response) => {
      let jwt = jwtDecode(response.data.data.token);
      setToken(response.data.data.token);

      FullStoryAPI('identify', jwt.user_id, {
        displayName: `${jwt.first_name} ${jwt.last_name}`,
        email: jwt.email,
        uid: jwt.user_id,
      });

      return setDeep(response, `data.data`, (n) => ({
        ...n,
        service_provider_ids: jwt.service_provider_ids,
        defaultTrackedPhoneId: jwt.default_tracked_phone_id,
        user_id: jwt.user_id,
        tresio_user: jwt.tresio_user,
        first_name: jwt.first_name,
        last_name: jwt.last_name,
      }));
    },
    callback: (data, err) => {
      if (!err) {
        if (data.tresio_user === '1') {
          return action('LOGIN_TRESIO_USER');
        }
        getServiceProvider(data.service_provider_ids[0], (res) => {
          action('LOGIN_STANDARD_USER', data.service_provider_ids[0]);
        });
      }
    },
  });
};

export const getUserProfile = (callback) => {
  return get('/user/info', {
    action: 'GET_USER_PROFILE',
    callback,
  });
};

export const patchUserProfile = (data, callback) => {
  return post('/user/update', {
    data,
    action: 'PATCH_USER_PROFILE',
    callback,
  });
};

export const postPasswordResetEmail = (email, callback) => {
  return post('/user/forgot-pw', {
    headers: {
      'Content-Type': 'string',
    },
    data: { email },
    action: 'POST_PASSWORD_RESET_EMAIL',
    callback,
  });
};

export const getPasswordResetToken = (hash, callback) => {
  return get(`/user/reset-pw/${hash}`, {
    action: 'GET_USER_TOKEN',
    callback,
  });
};

export const postPasswordReset = (newPassword, hash, callback) => {
  return post(`/user/reset-pw/${hash}`, {
    data: {
      new_pw: newPassword,
    },
    action: 'POST_PASSWORD_RESET',
    callback,
  });
};

export const getUserToken = ({ serviceProviderId, callback }) => {
  return get(`/user/token`, {
    query: {
      service_provider_id: serviceProviderId,
    },
    action: 'GET_USER_TOKEN',
    callback,
  });
};

export const getUserImpersonationToken = ({ serviceProviderId, userId, callback }) => {
  return get(`/user/token`, {
    query: {
      service_provider_id: serviceProviderId,
      user_id: userId,
    },
    action: 'GET_IMPERSONATION_TOKEN',
    callback,
  });
};

export const putUserNotification = (data) => {
  return put(`/service-provider/provider/${data.serviceProviderId}/user-notification`, {
    data: {
      ...(data.userId ? { user_id: data.userId } : {}),
      ...(data.email ? { email: data.email } : {}),
      ...(data.text ? { text: data.text } : {}),
      ...(data.destinationPhoneId === null || data.destinationPhoneId ? { destination_phone_id: data.destinationPhoneId } : {}),
    },
    action: 'PUT_USER_NOTIFICATION',
    callback: data.callback,
  });
};
